import React from 'react'
import styles from './styles.module.css'


const ConfirmModal = ({ isOpen, title, text, onConfirm, onCancel, confirmText = 'Удалить', cancelText = 'Отмена' }) => {
  if (!isOpen) return null
  return (
    <div className={styles.confirmOverlay} onClick={onCancel}>
      <div className={styles.confirmBox} onClick={e => e.stopPropagation()}>
        <div className={styles.confirmTitle}>{title}</div>
        <div className={styles.confirmText}>{text}</div>
        <div className={styles.confirmActions}>
          <button className={`${styles.confirmBtn} ${styles.confirmBtnDanger}`} onClick={onConfirm}>
            {confirmText}
          </button>
          <button className={styles.confirmBtn} onClick={onCancel}>{cancelText}</button>
        </div>
      </div>
    </div>
  )
}


export default ConfirmModal